import React from 'react';
import { Form, Field, reduxForm } from 'redux-form'
import { ReduxCheckBoxField } from '../../components/ReduxInput';

import { FormGroup, Label, Button, Row, Card, CardHeader, CardBody, Col } from 'reactstrap';

class PersonalSettingsForm extends React.Component {

    render() {
        const { handleSubmit } = this.props;
        return (


            <Card>
                <CardHeader>
                    Email Alerts
            </CardHeader>
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                    {/*}
                        <FormGroup check className="checkbox">
                            <Field
                                id={"rateRequestAlert"}
                                name={"rateRequestAlert"}
                                component={ReduxCheckBoxField}
                            />
                            <Label check className="form-check-label" htmlFor="checkbox1">Rate Requests</Label>
                        </FormGroup>
                        <FormGroup check className="checkbox">
                            <Field
                                id={"jobRequestAlert"}
                                name={"jobRequestAlert"}
                                component={ReduxCheckBoxField}
                            />
                            <Label check className="form-check-label" htmlFor="checkbox1">Job Requests</Label>
                        </FormGroup>
        */}
                        <FormGroup check className="checkbox">
                            <Field
                                id={"platformAccessAlert"}
                                name={"platformAccessAlert"}
                                component={ReduxCheckBoxField}
                            />
                            <Label check className="form-check-label" htmlFor="checkbox1">Access Request</Label>
                        </FormGroup>

                        <FormGroup className="pt-3">
                            <Button id="updateButton" type="submit" color="primary">
                                Update
                    </Button>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>

        );
    }
}

export default reduxForm({
    form: 'PersonalSettingsForm', // a unique identifier for this form
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true
})(PersonalSettingsForm);



// WEBPACK FOOTER //
// ./src/components/PersonalSettingsForm/PersonalSettingsForm.js